import axios from "axios";
import redirectToLoginOnSessionExpiry from "./Auth"

const apiUrl = process.env.VUE_APP_API_URL;

// MC-359 - Alice Serina 30/03/2026
// making AxiosInstance a singleton so there is only one axios to 
// intercept all requests

const axiosInstance = axios.create({
    withCredentials: true,
});

// Attach interceptor to redirect to login page when server returns 
// status 401
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401 || error?.response?.status === 419) {
      redirectToLoginOnSessionExpiry();
    }
    return Promise.reject(error);
  }
);

export default class BaseApi {
    static async startRequest() {
        await BaseApi.getAxiosInstance().get(apiUrl + "sanctum/csrf-cookie");
    }
    construct() {}
    
    static getApiUrl() {
        return apiUrl;
    }


    static getAxiosInstanceDownload(url){
        return axiosInstance({
            url: url,
            method: "GET",
            responseType: "blob", // important
          })
    }

    static getAxiosInstance() {
        return axiosInstance;
    }
}